import React from "react";
import { useLocation } from "react-router-dom";
import MasterLayout from "../otherImages/MasterLayout";
import ProductDataTable from "../components/ProductsDataTable";
import DefaultTopBar from "../components/DefaultTopBar";

const ManagePackages = () => {
  const location = useLocation();

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout> 

        <DefaultTopBar
            title="Products"
            desc="View, create, edit products."
            btnText="Add New Product"
            btnLink="/add-product" 
            btnState={{ from: `${location.pathname}${location.search}` }}
        />

        {/* TableDataLayer */}
        <ProductDataTable />

      </MasterLayout>

    </>
  );
};

export default ManagePackages; 
